<div class="wrapper" id="multiDeleteWrapper">
  <div class="close-button" (click)="close()"><mat-icon>close</mat-icon></div>
  <div class="photos">
    <div class="photo" *ngFor="let photo of photos">
      <ng-container *ngIf="photo?.data">
        <img
          [src]="transform(photo.data.url)"
          alt=""
          (press)="handlePress(photo)"
          (click)="handlePressUp(photo, $event)"
          (contextmenu)="stopContextMenu($event)"
        />
        <div
          class="checkbox position-container-top-right"
          [class.selected]="isSelected(photo)"
          (click)="toggleSelection(photo)"
        >
          <mat-icon>check</mat-icon>
        </div>
        <mat-chip-list class="position-container-bottom-right">
          <mat-chip>{{ photo.index + 1 }}/{{ photos.length }}</mat-chip>
        </mat-chip-list>
      </ng-container>
    </div>
  </div>
  <div class="footer">
    <span class="selection" *ngIf="selected.length > 0"
      >{{ selected.length }}/{{ photos.length }}
      <span class="small-text">(selected)</span></span
    >
    <button
      mat-stroked-button
      class="main-action-button"
      [class]="this.selected.length < 1 ? 'greyed' : null"
      (click)="submitSelected()"
    >
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>
</div>
